exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#read-only-editor[data-v-6d7c0aec]{overflow:scroll}\n", ""]);
